module.exports = __webpack_public_path__ + "static/media/3.2 KC Tribunj 2-14.08.2025..dfcf6621.png";